import { AnimatePresence, motion } from "framer-motion"
import { Outlet, useLocation } from "react-router-dom"

import { FooterCta } from "@/components/landing/FooterCta"
import { ScrollToTop } from "@/components/landing/ScrollToTop"
import { SiteFooter } from "@/components/landing/SiteFooter"
import { SiteHeader } from "@/components/landing/SiteHeader"
import { RouteSeo } from "@/components/SEO/RouteSeo"

export function MarketingLayout() {
  const location = useLocation()
  const isHome = location.pathname === "/"

  return (
    <div className="flex min-h-svh flex-col bg-background text-foreground">
      <RouteSeo />
      <ScrollToTop />
      <SiteHeader />
      <AnimatePresence mode="wait">
        <motion.div
          key={location.pathname}
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ duration: 0.32, ease: [0.22, 1, 0.36, 1] }}
          className="flex-1"
        >
          <Outlet />
        </motion.div>
      </AnimatePresence>
      {!isHome && <FooterCta />}
      <SiteFooter />
    </div>
  )
}
